<svelte:head>
  <title>Needs | A Good Thing</title>
</svelte:head>

<h1 class="title">Charity needs</h1>

<h2 class="is-size-4 mb-5">
  <div class="field has-addons">
    <div class="control is-expanded">
      <PostcodeInput bind:postcode />
    </div>
    <div class="control">
      <div class="select" style="font-size:1rem;">
        <select bind:value={distance}>
          <option value={1} selected={distance === 1}>1 mile</option>
          <option value={2} selected={distance === 2}>2 miles</option>
          <option value={3} selected={distance === 3}>3 miles</option>
          <option value={5} selected={distance === 5}>5 miles</option>
          <option value={10} selected={distance === 10}>10 miles</option>
          <option value={20} selected={distance === 20}>20 miles</option>
          <option value={30} selected={distance === 30}>30 miles</option>
          <option value={50} selected={distance === 50}>50 miles</option>
        </select>
      </div>
    </div>
  </div>
</h2>

<h2 class="is-size-6 mb-5">
  {#if loading}
    Loading needs...
  {:else if postcode}
    {#if items.length > 0}
      Showing charity needs near {postcode}.
    {:else}
      There are currently no charity needs within {distance} mile{distance > 1
        ? 's'
        : ''} of {postcode}.
    {/if}
  {:else}
    Showing charity needs in all locations. Enter your postcode to find
    local charity needs.
  {/if}
</h2>

<NeedsList {items} />


<script lang="ts">
  import _ from 'lodash';
  import PostcodeInput from '../../_components/PostcodeInput.svelte';
  import NeedsList from './_components/NeedsList.svelte';

  let loading = false;

  let items: any[] = [];

  let firebase = window.firebase;

  let postcode = '';
  let distance = 20;

  $: getNeeds(postcode, distance);

  async function getNeeds(postcode: string, distance: number) {
    let params;

    if (postcode) {
      const location: any = await getPostcode(postcode);

      params = {
        long: location.longitude,
        lat: location.latitude,
        distance,
      };
    }

    loading = true;

    firebase
      .functions()
      .httpsCallable('api-need-getneeds')(params)
      .then((response) => {
        items = response.data;
      })
      .finally(() => {
        loading = false;
      });
  }

  async function getPostcode(postcode: string) {
    return fetch(`https://api.postcodes.io/postcodes/${postcode}`)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        return data.result;
      });
  }
</script>
